import { HIVE_OUTLINE_NOTICE, OutlineNotice } from './body/outline-notice';
import {
  HIVE_OUTLINE_PANEL_BODY,
  OutlinePanelBody,
} from './body/outline-panel-body';
import { HIVE_OUTLINE_NOTE_CARD, OutlineNoteCard } from './card/outline-card';
import {
  HIVE_OUTLINE_BLOCK_PREVIEW,
  OutlineBlockPreview,
} from './card/outline-preview';
import {
  HIVE_OUTLINE_PANEL_HEADER,
  OutlinePanelHeader,
} from './header/outline-panel-header';
import {
  HIVE_OUTLINE_NOTE_PREVIEW_SETTING_MENU,
  OutlineNotePreviewSettingMenu,
} from './header/outline-setting-menu';
import {
  HIVE_MOBILE_OUTLINE_MENU,
  MobileOutlineMenu,
} from './mobile-outline-panel';
import { HIVE_OUTLINE_PANEL, OutlinePanel } from './outline-panel';
import { HIVE_OUTLINE_VIEWER, OutlineViewer } from './outline-viewer';

export function effects() {
  customElements.define(
    HIVE_OUTLINE_NOTE_PREVIEW_SETTING_MENU,
    OutlineNotePreviewSettingMenu
  );
  customElements.define(HIVE_OUTLINE_NOTICE, OutlineNotice);
  customElements.define(HIVE_OUTLINE_PANEL, OutlinePanel);
  customElements.define(HIVE_OUTLINE_PANEL_HEADER, OutlinePanelHeader);
  customElements.define(HIVE_OUTLINE_NOTE_CARD, OutlineNoteCard);
  customElements.define(HIVE_OUTLINE_VIEWER, OutlineViewer);
  customElements.define(HIVE_MOBILE_OUTLINE_MENU, MobileOutlineMenu);
  customElements.define(HIVE_OUTLINE_BLOCK_PREVIEW, OutlineBlockPreview);
  customElements.define(HIVE_OUTLINE_PANEL_BODY, OutlinePanelBody);
}
